import React from 'react';
import '../styles/Card.css';

const Card = ({ cardName, cardImage, animationDuration, randomRotation }) => {
  return (
    <div 
      className="card-container" 
      style={{
        '--animation-duration': `${animationDuration}s`,
        '--start-rotation': `${randomRotation.start}deg`,
        '--mid-rotation': `${randomRotation.mid}deg`,
        '--start-x': `${randomRotation.startX}px`,
        '--mid-x': `${randomRotation.midX}px`,
      }}
    >
      <div className="card card-flip-in">
        {cardImage && (
          <img 
            src={`/cartas/${cardImage}`} 
            alt={cardName}
            className="card-image"
          />
        )}
      </div>
    </div>
  );
};

export default Card;
